var React = require('react');

function DmInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.6673 0.5L23.9115 3.74417L16.9982 10.6575L11.3315 4.99083L0.833984 15.5025L2.83148 17.5L11.3315 9L16.9982 14.6667L25.9232 5.75583L29.1673 9V0.5H20.6673Z","fill":"#FFC043"}));
}

DmInline.defaultProps = {"width":"30","height":"18","viewBox":"0 0 30 18","fill":"none"};

module.exports = DmInline;

DmInline.default = DmInline;
